import {
  createPlugin,
  createComponentExtension,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const mysecondbackstagepluginPlugin = createPlugin({
  id: 'mysecondbackstageplugin',
  routes: {
    root: rootRouteRef,
  },
});

export const MysecondbackstagepluginPage =
  mysecondbackstagepluginPlugin.provide(
    createRoutableExtension({
      name: 'MysecondbackstagepluginPage',
      component: () =>
        import('./components/ExampleComponent').then(m => m.ExampleComponent),
      mountPoint: rootRouteRef,
    }),
  );

export const AdviceCard = mysecondbackstagepluginPlugin.provide(
  createComponentExtension({
    name: 'AdviceCard',
    component: {
      lazy: () => import('./components/AdviceCard').then(m => m.AdviceCard),
    },
  }),
);

export const TodoCard = mysecondbackstagepluginPlugin.provide(
  createComponentExtension({
    name: 'TodoCard',
    component: {
      lazy: () => import('./components/TodoCard').then(m => m.TodoCard),
    },
  }),
);
